// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-container[data-v-5915bc44] {\n     margin: .5em 2em 2em 2em;\n}\n", ""]);
// Exports
module.exports = exports;
